$('.tribe-events-event-image img').each((index, obj) => {
    $(obj).removeAttr('width')
    $(obj).removeAttr('height')
})